<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24" style="display: flex;">
                <div>
                  <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                  <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel" :disabled="!power.oil_order_excel">导出Excel</el-button>
                </div>
                <!-- <div style="padding-left: 10px;"><el-tag effect="plain">总合计金额：{{total_amount_sum}}</el-tag></div> -->
                <!-- <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true">新增</el-button> -->
                <!-- <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icon-shanchu shuaxin">删除</el-button> -->
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item">
                  <el-date-picker
                    v-model="data.created_at"
                    size="small"
                    :picker-options="pickerOptions"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    start-placeholder="下单开始时间"
                    end-placeholder="下单结束时间">
                  </el-date-picker>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.staff_id" placeholder="请选择员工" size="small" clearable>
                        <el-option
                            v-for="item in staffList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.is_pay" placeholder="请选择支付状态" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: 1, name: '已支付'},
                              {id: 0, name: '未支付'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-input v-model="data.phone" size="small" type="number" placeholder="请输入会员手机号码" clearable></el-input>
                </div>
                <div class="search-item" style="width: 120px;">
                    <el-select v-model="data.payment_type" placeholder="支付类型" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: 1, name: '微信支付'},
                              {id: 2, name: '油卡支付'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="order_no" label="订单编号" width="160"></el-table-column>
                    <el-table-column prop="user_name" label="会员昵称" width="160"></el-table-column>
                    <el-table-column prop="phone" label="手机号码" width="130"></el-table-column>
                    <el-table-column prop="price" label="单价" width="110"></el-table-column>
                    <el-table-column prop="discount_money" label="优惠金额" width="80"></el-table-column>
                    <el-table-column prop="coupon_money" label="优惠券" width="80"></el-table-column>
                    <el-table-column prop="actual_money" label="实付金额" width="110"></el-table-column>
                    <el-table-column prop="total_amount" label="合计金额" width="110"></el-table-column>
                    <el-table-column prop="petrol_money" label="汽油余额" width="110"></el-table-column>
                    <el-table-column prop="diesel_money" label="柴油余额" width="110"></el-table-column>
                    <el-table-column prop="staff_name" label="加油员" width="110"></el-table-column>
                    <el-table-column prop="oil_gun_id" label="油枪号" width="110">
                      <template slot-scope="scope">
                        <span>{{scope.row.oil_gun_num}}号枪[{{scope.row.oil_gun_param}}]</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="oil_total" label="多少升" width="120"></el-table-column>
                    <el-table-column prop="payment_type" label="支付类型" width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.payment_type == 1">微信支付</span>
                        <span v-if="scope.row.payment_type == 2">油卡支付</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="is_pay" label="支付状态" width="120">
                      <template slot-scope="scope">
                        <span v-if="scope.row.is_pay == 1" style="color: #67C23A;">已支付</span>
                        <span v-if="scope.row.is_pay == 0" style="color: #F56C6C;">未支付</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="下单时间" min-width="180"></el-table-column>
                    <!-- <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain>编辑</el-button>
                            <el-button @click="del(scope.row.id)" icon="iconfont icon-shanchu shuaxin" size="mini" type="danger" plain>删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <!-- <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" @close="dialogClose" width="550px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="订单编号"
                    :label-width="formLabelWidth"
                    prop="order_no"
                    :rules="[
                    { required: false, message: '请输入订单编号', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.order_no" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog> -->
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {OilOrderIndex, DataAdd, DataDel} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    staff_id: '',
                    is_pay: '',
                    phone: '',
                    created_at: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增XXX",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    order_no: "",
                },
                total_amount_sum: 0,
                staffList: [],
                multipleSelection: [],
                pickerOptions: {
                  shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近一个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                    }
                  }, {
                    text: '最近三个月',
                    onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                    }
                  }]
                },
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power", "loginInfo"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                OilOrderIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.total_amount_sum = res.data.total_amount_sum
                        this.staffList = res.data.staffList
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        DataAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    order_no: data.order_no,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑XXX" : "新增XXX"
                this.dialogFormVisible = true
            },
            dialogClose() {
                this.initForm()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    order_no: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增XXX"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    DataDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  if (this.loginInfo.id == 1) {
                    url += `&auth=xj2020`
                  }
                  location.href = this.loginInfo.app_url+'/manage/oil-order/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
              });
            },
        }
    }
</script>

<style>
</style>
